import { Container } from "react-bootstrap"
import SignUpForm from "../../components/SignUpForm/SignUpForm"


const SignUpPage = () => {
    return (
        <Container>

            <SignUpForm />
        </Container>
    )
}

export default SignUpPage